import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Category, CategoryResponse } from 'src/app/stores/category.store';
import { imageUrl } from 'src/environments/environment';

@Component({
  selector: 'app-store-category-filter',
  templateUrl: './store-category-filter.component.html',
  styleUrls: ['./store-category-filter.component.scss'],
})
export class StoreCategoryFilterComponent implements OnInit {
  @Input() categories: CategoryResponse;
  imgurl = imageUrl;
  constructor(private modalCtrl: ModalController,public translate: TranslateService) {}

  ngOnInit() {}

  selectCategory(category: Category) {
    const resp = {
      category: category,
    };
    this.modalCtrl.dismiss(resp);
  }
}
